import { api } from 'application/api'
import { markFavoriteMessageSucceed } from 'application/redux/actions/pages/akten'
import { call, put } from 'redux-saga/effects'

export function* markFavoriteMessageSaga(action) {
    yield call(api.gateway.pages.postMarkFavoriteMessage, action.accountId, action.messageId)
    yield put(markFavoriteMessageSucceed())
}
